export enum MercerSurveyType {
  Default = 'Default',
  ProjectManagement = 'ProjectManagement'
}
